package dateio

@JsModule("@date-io/date-fns")
@JsNonModule
private external val DateFnsUtilsModule: dynamic

@Deprecated("Don't use this value directly, it's already used inside the proper components.")
internal val DateFnsUtils: dynamic = DateFnsUtilsModule.default